import React from 'react'
import styled from 'styled-components'
import { css } from 'styled-components'
import { CashCoin, Lightbulb, Clock } from "react-bootstrap-icons";

//import components
import FormAbout from '../../components/FormAbout'
import Label from '../../components/Label'
import StyledButton from '../../components/Button'
import Input from '../../components/Input'
import Textarea from '../../components/Textarea'

const WrapperGrid = styled.div`
    ${props => props.full && css`
        grid-column: 1 / 3;
        border: 1px solid red;
    `}
`;



const AboutData = () => (
    <div>
    
        <FormAbout>
            <WrapperGrid>
              <CashCoin className="abt" />
            </WrapperGrid>
            <WrapperGrid>
                <p className='abt-header'>Cost Effective Solutions</p>
                <p className='abt-text'>We use Lipa Na Mpesa to ensure there are no extra charges when transacting. We also offer discounts on some of our products to our customers </p>
            </WrapperGrid>
            <WrapperGrid>
                <Lightbulb className="abt" />
                
            </WrapperGrid>
            <WrapperGrid>
            <p className='abt-header'>Innovative</p>
            <p className='abt-text'>We use the latest technologies and processes in order to improve the customer experience when interacting with any of our products and services</p>
            </WrapperGrid>
            <WrapperGrid>
               <Clock className="abt"  />
                
            </WrapperGrid>
            <WrapperGrid>
            <p className='abt-header'>24/7 Support</p>
            <p className='abt-text'>Our customer service agents are always on hand to offer support and answer any queries our customers may have. The support line is <b>0715 532 259 </b> or email <b>info@getairtime.co.ke</b> </p>
            </WrapperGrid>
        </FormAbout>
    </div>
)

export default AboutData